import {connect} from '@modifi/redux'

import {SectionNavigationContainer} from '../../../../plugins/onboarding'
import {selectNavigationItems} from '../../store'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: Record<string, any>, ownProps: {sectionName: string}) => ({
  items: selectNavigationItems(state, ownProps.sectionName),
})

export default connect(mapStateToProps)(SectionNavigationContainer)
